import { DistributorScene } from 'types/Activity'

export function getPercentComplete(currentSceneUuid: string, scenes: DistributorScene[]) {
  const currentSceneIndex = scenes.findIndex((scene) => scene.uuid === currentSceneUuid)
  const totalScenes = scenes.length

  return (currentSceneIndex / totalScenes) * 100
}
